<template>
  <div class="card pt-10">
    <RequiredText />
    <form id="recurrentExpenseForm" @submit.prevent="submitForm">
      <div class="row">
        <Input
            containerClass="col-md-4"
            name="recurrent-expense-title"
            type="text"
            :label="$t('recurrentExpense.label.title')"
            labelClass="form-label fs-6 text-black"
            :inputClass="'form-control form-control-sm form-control-solid'"
            :isRequired="true"
            size="lg"
            :placeholder="$t('recurrentExpense.placeholder.title')"
            v-model="formData.title">
        </Input>
        <div class="col-md-8">
          <div class="row">
            <div class="col-12">
              <div class="row align-items-center">
                <div class="col-md-4 d-flex">
                  <Input
                      container-class="form-group w-50"
                      type="number"
                      :label="$t('recurrentExpense.label.frequency')"
                      label-class="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-sm form-control-solid rounded-end-0'"
                      :name="`recurrent-expense-frequency-type`"
                      :placeholder-text="$t('expense.label.reason')"
                      v-model="formData.frequency"
                  />
                  <Select2
                      container-class="form-group w-50 d-flex mt-auto"
                      :multiple="false"
                      :show-search="false"
                      label-class="form-label fs-6 text-black"
                      :selectClass="'form-select form-control-sm form-select-solid rounded-start-0 w-100'"
                      :name="`recurrent-expense-frequency-id`"
                      :placeholder-text="$t('expense.label.reason')"
                      v-model="formData.interval">
                    <option v-for="(frequency, index) in recurringFrequencyEnum" :value="frequency.value" :key="index">
                      {{ frequency[locale] }}
                    </option>
                  </Select2>
                </div>
                <InputDate
                    containerClass="col-12 col-md-4"
                    name="recurrent-expense-start-date"
                    :label="$t('recurrentExpense.label.startDate')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-sm form-control-solid'"
                    :isRequired="true"
                    size="lg"
                    :placeholder="$t('recurrentExpense.placeholder.startDate')"
                    v-model="formData.start_date" />
                <InputDate
                    containerClass="col-12 col-md-4"
                    name="recurrent-expense-end-date"
                    :label="$t('recurrentExpense.label.endDate')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-sm form-control-solid'"
                    :isRequired="true"
                    size="lg"
                    :placeholder="$t('recurrentExpense.placeholder.endDate')"
                    v-model="formData.end_date" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <ExpenseRecurrentReasonForm
            v-for="(reason, index) in formData.fees"
            :key="index"
            :id="'recurrent-expense-fee-'+index"
            :index="index"
            :fee="reason"
            :currency="'XOF'"
            :show-file="showAddFileInput"
            @delete-row="removeReasonRow"/>
        <div class="d-flex justify-content-end align-items-end float-end my-5">
          <a class="btn btn-primary" @click.prevent="addReasonRow">
            {{ $t('expense.new.addFee') }}
          </a>
        </div>
      </div>

      <div class="card-footer d-flex justify-content-end">
        <Button type="cancel" btn-class="me-2" btn-text="button.cancel" @click.prevent="cancel"></Button>
        <Button type="submit" btn-text="button.save" :isDisabled="submitting" :isLoading="submitting"></Button>
      </div>
    </form>
  </div>
</template>

<script setup>

import {useStore} from "vuex";
import {defineProps, ref, onMounted, computed, watch} from "vue";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue";
import {useRoute, useRouter} from 'vue-router';
import RequiredText from "@/components/RequiredText.vue"
import InputDate from "@/components/InputDate.vue";
import ExpenseRecurrentReasonForm from "@/components/ExpenseRecurrent/ExpenseRecurrentReasonForm.vue";
import Select2 from "@/components/Select2.vue";
import {useLocales} from "@/composables/locales";

const { locale } = useLocales()

const store = useStore()
const router = useRouter()
const route = useRoute()

const props = defineProps({
  isEdit: { type: Boolean, default: false },
  recurrentExpense: {
    type: Object,
    default: () => ({
      id: null,
      office_id: '',
      title: '',
      frequency: "",
      interval: "",
      start_date: "",
      end_date: '',
      fees: [{
        id: '',
        amount: 0,
        reason_id: '',
        invoices: []
      }]
    })
  },
  submitForm: Function,
  submitting: {type: Boolean, default: false},
  expenseType: { type: Object, required: true }
})

const formData = ref(props.recurrentExpense)
const showAddFileInput = ref(false)

const recurringFrequencyEnum = computed(() => store.getters["invoices/recurringInvoiceFrequency"])

watch(() => formData.value.start_date, (value) => {
  const formattedValue = value.toString().split('-').reverse().join('/')
  const isToday = new Date(formattedValue).toDateString() === new Date().toDateString()
  if(!props.isEdit && isToday) {
    showAddFileInput.value = true
  }
})

const addReasonRow = () => {
  formData.value.fees.push({
    id: '',
    amount: 0,
    reason_id: '',
    invoices: []
  })
}
const removeReasonRow = (index) => {
  if (formData.value.fees.length > 1) {
    const [feeToDelete] = formData.value.fees.splice(index, 1)
    if(props.isEdit) {
      // formData.value?.feesToDelete.push(feeToDelete?.id)
    }

  }
}

function cancel(){
  router.push({ name: 'settings-recurrence-expense'})
}

onMounted(() => {
  if(props.expenseType?.id) {
    store.dispatch('reason/loadReasons', props.expenseType.id)
  }
  store.dispatch('expenses/loadExpenseTypes')
  store.dispatch('invoices/loadRecurringInvoiceFrequency')
})
</script>

<style scoped>

</style>
